module.exports = __webpack_public_path__ + "img/license_status_warning.f70554e7.svg";